<template>
  <div class="pm-dialog-order-at">

    <div class="vs-row flex justify-center">
      <div class="flex justify-center input-label">
        日付
      </div>
      <div>
        <div class="display-date">
          {{displayDate}}
        </div>
        <div class="arrow-button-area">
          <div class="arrow-button" :class="{disabled: !isBeforeDayValid}" @click="reduceDate">◀︎</div>
          <div class="arrow-button" :class="{disabled: !isNextDayValid}" @click="addDate">▶︎</div>
        </div>
      </div>
      <div class="flex justify-center input-label">
        時刻
      </div>
      <div @mousedown="selectedInput = 0" >
        <vs-input-number 
          v-model="hour"
          color="#bdbdbd"
          :min="0"
          :max="23"
          class="order-at-input"
          :class="[ 
            ( ( !hour && hour !== 0 )  ? 'input-null' : ( !validHour ? 'input-invalid' : 'input-any' ) ), 
            ( this.selectedInput === 0 ? 'border-selected' : null )
          ]"
        />
      </div>
      <div class="flex input-label">
      :
      </div>
      <div @mousedown="selectedInput = 1">
        <vs-input-number 
          v-model="minute"
          color="#bdbdbd"
          :min="0"
          :max="59"
          class="order-at-input"
          :class="[ 
            ( ( !minute && minute !== 0 ) ? 'input-null' : ( !validMinute ? 'input-invalid' : 'input-any' ) ), 
            ( this.selectedInput === 1 ? 'border-selected' : null )
          ]"                
        />
      </div>
    </div>
    <div class="vs-row flex justify-center number-input-area">
      <div v-for="(master,index) in masterList" :key="index"  class="pm-dialog-order-at-col" @mousedown="onKeyDown(master.id)" >
        <vs-chip class="pm-input-key" >
          {{ master.name }}
        </vs-chip>
      </div>
    </div>

    <div class="vs-row flex justify-center">
      <vs-button 
        style="margin:1rem;width:8rem;"
        color="#828282"
        onMouseOut="this.style.background='#828282'" 
        onMouseOver="this.style.background='#2d9cdb'"
        @mousedown="onSetNow"
      >現在時刻</vs-button>
      <vs-button 
        style="margin:1rem;width:8rem;"
        color="#828282"
        onMouseOut="this.style.background='#828282'" 
        onMouseOver="this.style.background='#2d9cdb'"
        @mousedown="onClear"
      >クリア</vs-button>
    </div>
    <div class="flex justify-center">
      <vs-button 
        :color="isValidTime ? '#2d9cdb' : '#bdbdbd'"
        :disabled="!isValidTime"
        class="save-button"
        @mousedown="onSubmit(false)"
        v-shortkey="{save: ['enter'], saveWithUpdateTime: ['shift', 'enter']}" @shortkey="callKeyActions"
      >
        保存
      </vs-button>
      <vs-button
        v-if="!isImportEditMode && !isInsertOneMode"
        :color="isValidTime ? '#2d9cdb' : '#bdbdbd'"
        :disabled="!isValidTime"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>
  </div>

</template>

<script>
import { createNamespacedHelpers } from "vuex";
import Vue from "vue";
const { mapState } = createNamespacedHelpers("portMasterDestinationWorkEdit");
import moment from "moment-timezone";
export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
    isImportEditMode: { type: Boolean,  default: false },
    isInsertOneMode:  { type: Boolean,  default: false },
  },
  data() {
    return {
      selectedInput: 0,
      selectedId: -1,
      hour: null,
      minute: null,
      date: null,
      startMomentYmdhms: null,
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
      selectedDateDisplay1: state => state.selectedDateDisplay1,
    }),
    masterList() {
      return [
        { id: 0, name: 0 },
        { id: 1, name: 1 },
        { id: 2, name: 2 },
        { id: 3, name: 3 },
        { id: 4, name: 4 },
        { id: 5, name: 5 },
        { id: 6, name: 6 },
        { id: 7, name: 7 },
        { id: 8, name: 8 },
        { id: 9, name: 9 },
      ];
    },
    isValidTime(){
      if ( !this.validHour || !this.validMinute ) {
        return false;
      }
      const ymd = moment(this.date).local().format("YYYY-MM-DD") ;
      const hour   = ( '00' + this.hour   ).slice(-2);
      const minute = ( '00' + this.minute ).slice(-2);
      if ( moment(`${ymd}T${hour}:${minute}:00`).valueOf() < moment(this.startMomentYmdhms).valueOf() ) {
        // 当日の営業開始時間よりも前の時刻は無効扱い
        return false;
      }
      let dateStr = null
      if (this.isInsertOneMode) {
        dateStr = moment(this.date).format("YYYYMMDD")
      } else {
        dateStr = this.valueMap.value ? moment(this.valueMap.value).format("YYYYMMDD") : this.selectedDateDisplay1;
      }
      const dispDate = dateStr.slice(0,4) + '-' + dateStr.slice(4,6) + '-' + dateStr.slice(6,8);
      const newDateStr = dispDate + " " + this.hour + ":" + this.minute + ":00";
      const targetDate = new Date(newDateStr);
      Vue.$log.debug("targetDate",!!targetDate,targetDate);
      if (this.isInsertOneMode) {
        const hourIntervalObj = this.masterMap['tasks'].find(x => x.id === 'hour_interval');
        let hourIntervalStrings = hourIntervalObj ? hourIntervalObj.value.split(":") : "00:00".split(":");
        let hourInterval = hourIntervalStrings[1] != "00" ? Number(hourIntervalStrings[0]) + Number(hourIntervalStrings[1])/60 : Number(hourIntervalStrings[0])
        return moment(targetDate).isSameOrAfter(moment(this.selectedDateDisplay1).add(hourInterval, "hours")) && moment(targetDate).isBefore(moment(this.selectedDateDisplay1).add(1, "days").add(hourInterval, "hours"))
      } else {
        return !!targetDate;
      }
    },
    validHour() {
      return this.hour === 0 || this.hour && !isNaN(this.hour) &&  Number(this.hour) < 24 
    },
    validMinute() {
      return this.minute === 0 || this.minute && !isNaN(this.minute) &&  Number(this.minute) < 60 
    },
    isBeforeDayValid() {
      return (!moment(this.date).add(-1, "days").isBefore(moment(this.startMomentYmdhms), 'days') && !this.isInsertOneMode) || 
             (this.isInsertOneMode && !moment(this.date).add(-1, "days").isBefore(moment(this.selectedDateDisplay1), 'days'))
    },
    isNextDayValid() {
      const selectableDays = 5;
      return (!moment(this.date).add( 1, "days").isAfter(moment().add(selectableDays, 'days'), 'days') && !this.isInsertOneMode) || 
             (this.isInsertOneMode && !moment(this.date).add(1, "days").isAfter(moment(this.selectedDateDisplay1).add(1, "days"), 'days'))
    },
    displayDate() {
      return moment(this.date).format("MM/DD")
    }
  },
  methods: {
    initData() {
      this.selectedInput = 0;
      this.selectedId = this.valueMap ? this.valueMap.id : -1;
      this.hour   = this.valueMap && this.valueMap.value ? moment(this.valueMap.value).local().format("HH") : "" ;
      this.minute = this.valueMap && this.valueMap.value ? moment(this.valueMap.value).local().format("mm") : "" ;
      this.date = this.valueMap && this.valueMap.value ? moment(this.valueMap.value) : this.selectedDateDisplay1
      const hourIntervalObj = this.masterMap['tasks'].find(x => x.id === 'hour_interval');
      let hourIntervalString = hourIntervalObj ? hourIntervalObj.value : "00:00";
      this.startMomentYmdhms = moment().local().format("HH:mm") >  hourIntervalString
        ?  `${moment().local().format("YYYY-MM-DD")}T${hourIntervalString}:00`
        :  `${moment().local().add(-1, 'days').format("YYYY-MM-DD")}T${hourIntervalString}:00`;

    },
    onKeyDown(key){
      if ( this.selectedInput === 0) {
        this.hour = this.hour && ( this.hour * 10 + key ) % 100 < 24 ? ( this.hour * 10 + key ) % 100 : key;
      }
      if ( this.selectedInput === 1) {
        this.minute = this.minute && ( this.minute * 10 + key ) % 100 < 60 ? ( this.minute * 10 + key ) % 100 : key;
      }
    },
    onSetNow() {
      this.hour = moment().local().format("HH");      
      this.minute = moment().local().format("mm");      
    },
    onClear() {
      if ( this.selectedInput !== 1) {
        this.hour   = "";
      }
      if ( this.selectedInput === 1) {
        this.minute = "";
      }
    },
    addDate() {
      if (this.isNextDayValid) this.date = moment(this.date).add(1, "days")
    },
    reduceDate() {
      if (this.isBeforeDayValid) this.date = moment(this.date).add(-1, "days")
    },
    callKeyActions(event) {
      switch (event.srcKey) {
      case 'save':
        if (this.isValidTime) this.onSubmit(false, true)
        break
      case 'saveWithUpdateTime':
        if (this.isValidTime) this.onSubmit(true, true)
        break
      }
    },
    onSubmit(isUpdateTimeStamp, toNextColumn = false) {
      let mode = []
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      if (toNextColumn) mode.push("toNextColumn")
      let dateStr = this.date ? moment(this.date).format("YYYYMMDD") : this.selectedDateDisplay1;
      const dispDate = dateStr.slice(0,4) + '-' + dateStr.slice(4,6) + '-' + dateStr.slice(6,8);
      const newDateStr = dispDate + " " + this.hour + ":" + this.minute + ":00";
      const newDate = new Date(newDateStr);
      Vue.$log.debug("newDateStr", newDateStr, newDate);

      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey] = isNaN(newDate) ? null : newDate;
      this.$emit('updateValue',this.taskId, updateKeyValueMap, mode, this.columnKey);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
.pm-dialog-order-at {
  .vs-con-input-label  {
    width: 4rem;
    .vs-input--input {
      height: 3rem;
      text-align: center;
      background-color: $pm-white;
    }
  }
  .display-date {
    margin: 0.2rem 0.5rem !important;
    border: 1px solid rgba(0, 0, 0, 0.2);
    background-color: #f2f2f2;
    font-size: 140%;
    text-align: center;
    line-height: 2.6rem;
    height: 4rem;
    padding: .7rem;
    color: inherit;
    position: relative;
    border-radius: 5px;
    box-sizing: border-box;
    width: 6rem;
  }
  .arrow-button-area {
    margin-top: 5px;
    display: flex;
    justify-content: center;
  }
  .arrow-button {
    cursor: pointer;
    color: $pm-mouse-gray;
    &.disabled {
      cursor: default;
      color: $pm-paper-white;
    }
    user-select: none;
  }
  .order-at-input {
    margin: 0.2rem 0.5rem !important;
    border-radius: 5px;
    input {
      height: 4rem !important;
      border-radius: 5px;
      font-size: 150% !important;
    }
  }
  .border-selected {
    border: 0.2rem solid $pm-blue !important;
    box-sizing: border-box;
  }
  .number-input-area {
    margin-top: 10px;
  }
  .input-label {
    padding: 22px 10px;
  }
  .input-any {
    background-color: $pm-white;
  }
  .input-null {
    background-color: $pm-light-gray;
  }
  .input-invalid {
    background-color: rgba(203,57,79,0.4); //#CB4B4F;
  }
  .vs-input-number  {
    margin-bottom: 2rem !important;
    padding: 1rem 0;
    height: 4rem;
    width: 4rem;
    border: 0.05rem solid $pm-mouse-gray;
    border-radius: 0.2rem;
    input {
      min-width: 2.4rem ;
    }
    &--button-less{
      height: 1.5rem;
      min-width: 1.8rem;
      transform:translate(1.0rem,3.2rem) !important; 
    }
    &--button-plus{
      height: 1.5rem;
      min-width: 1.8rem;
      transform:translate(-1.0rem,3.2rem) !important; 
    }
  }

  .pm-input-key {
    background-color: $pm-paper-white;
    border: 1px solid $pm-gray;
    color: $pm-black;
    cursor: pointer;
    &:hover {
      background-color: $pm-blue;
      border: 1px solid $pm-blue;
      color: $pm-white !important;
    }
  }
  .pm-dialog-order-at-col {
    margin:0.2rem;
    padding: 0rem;
    .con-vs-chip {
      border-radius:6px;
      height:3rem;
      font-size: 120%;
      min-width: 3rem;
    }
  }
  .save-button {
    margin: 1rem !important;
    width: 30%;
  }
}
</style>

